module.exports = __webpack_public_path__ + "img/404.5bfdc974.svg";